/* src/app/common/components/custom-restaurant-select/restaurant-modal.component.scss */
ion-item.selected {
  background-color: #f5fff8;
  color: #000;
}
ion-item.selected ion-label {
  color: #000;
}
/*# sourceMappingURL=restaurant-modal.component.css.map */
